import React, { useEffect} from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import SidebarComponent from "./components/Sidebar";
import { ScoutingPage } from "./pages/Scouting";
import { ScoutingReport } from "./pages/ScoutingReport";
import { Guts } from "./pages/guts/Guts";
import Data from "./pages/Data";
import Charting from "./pages/Charting";
import { Recruiting } from "./pages/Recruiting";
import SignIn from "./pages/SignIn";
import { HomePage } from "./pages/HomePage";
import { Toaster } from "react-hot-toast";
import { PlayerPage } from "./pages/PlayerPage";
import { TeamPage } from "./pages/TeamPage";
import { ScoutingReportReport } from "./pages/reports/scouting-report/ScoutingReport";
import { Leaderboards } from "./pages/leaderboards";
import { GamePage } from "./pages/GamePage";
import { Scoreboard } from "./pages/Scoreboard";
import PlayerLists from "./pages/PlayerLists";
import { SprayChartsPage } from "./pages/spray-chart-page";
import { BaserunningReportPage } from "./pages/baserunning-report-page";
import { BaserunningReportRender } from "./pages/reports/baserunning-report";
import ApiKeys from "./pages/ApiKeys";
import AuthManager from "./managers/AuthManager";

const MainLayout = ({ children }) => (
  <div className="App flex h-screen">
    <SidebarComponent />
    <div className="content flex-grow overflow-auto">
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#333",
            color: "#fff",
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: "#4ade80",
              secondary: "#fff",
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
    </div>
  </div>
);

const AppRoutes = () => {
  const location = useLocation();
  const isRenderRoute = location.pathname.startsWith('/render/');

  if (isRenderRoute) {
    switch (location.pathname.split('/')[2]) {
      case "scouting-report":
        return (
          <Routes>
            <Route path="/render/scouting-report" element={<ScoutingReportReport />} />
          </Routes>
        );
      case "baserunning-report":
        return (
          <Routes>
            <Route path="/render/baserunning-report" element={<BaserunningReportRender />} />
          </Routes>
        );
      default:
        return null;
    }
  }

  return (
    <MainLayout>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/" element={<HomePage />} />  
        <Route path="/guts" element={<Guts />} />
        <Route path="/scouting" element={<ScoutingPage />} />
        <Route path="/scouting/:reportId/:slug" element={<ScoutingReport />} />
        <Route path="/recruiting" element={<Recruiting />} />
        <Route path="/charting" element={<Charting />} />
        <Route path="/data" element={<Data />} />
        <Route path="/player/:playerId" element={<PlayerPage />} />
        <Route path="/team/:teamId" element={<TeamPage />} />
        <Route path="scouting/reports/:reportId/spraycharts" element={<SprayChartsPage />} />
        <Route path="scouting/reports/:reportId/baserunning" element={<BaserunningReportPage />} />
        <Route path="/leaderboards" element={<Leaderboards />} />
        <Route path="/scoreboard" element={<Scoreboard />} />
        <Route path="/games/:year/:gameId" element={<GamePage />} />
        <Route path="/player-lists" element={<PlayerLists />} />
        <Route path="/api-keys" element={<ApiKeys />} />
      </Routes>
    </MainLayout>
  );
};

function App() {
  useEffect(() => {
    AuthManager.ensureUser("api");
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
